import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ProductMove, ProductMovePurpose } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ProductMoveService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  // public async getProductMove(id): Promise<ProductMove> {
  //   return new ProductMove(
  //     await this.core.services.productMove.getById(id, {
  //       id: null,
  //       name: null,
  //       type: null,
  //       color: null,
  //       externalId: null,
  //     })
  //   )
  // }

  // todo vsude kde se pouzivalo this.core.lists.productMoves -> byly to productMoves s vyfiltrovanm userem !!! takze tam pridat posilaní filter do params
  async getProductMoves(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: ProductMove[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.productMove.getList(parameters, schema)
  }

  // createProductMove(productMove: Partial<ProductMove>, schema: ProductMove): Promise<ProductMove> {
  //   return this.core.services.productMove.createWithTanstack(productMove, schema)
  // }

  // updateProductMove(productMove: Partial<ProductMove>, schema: ProductMove): Promise<ProductMove> {
  //   return this.core.services.productMove.updateWithTanstack(productMove, schema)
  // }

  deleteProductMove(productMove: Partial<ProductMove>): Promise<ProductMove> {
    return this.core.services.productMove.delete(productMove)
  }

  async getProductMovePurposes(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null }
  ): Promise<{
    items: ProductMovePurpose[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.productMove.getPurposes(parameters, schema)
  }
}
